import { isStreamIQ } from '@/shared/lib'

export async function getStreamIQConstants() {
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/shared/constantsStreamIq')
            return module.default
        } catch (error) {
            console.warn(
                'SeriesScreen module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
}
